import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";

function Prueba() {
    const [apps, setApps] = useState([]); // ← aquí guardamos nombre + datosApp de todas las apps
    const [appSeleccionada, setAppSeleccionada] = useState("");
    const [camposFormulario, setCamposFormulario] = useState([]);
    const [mensaje, setMensaje] = useState("");

    const BASE_URL = useOutletContext();
    // Obtener todas las apps y sus campos en una sola petición
    useEffect(() => {
        fetch(`${BASE_URL}/models.php`, {
            method: 'POST', // 👈 importante
            headers: {
                'Content-Type': 'application/json' // 👈 para que PHP lo lea como JSON
            },
            body: JSON.stringify({ page: 'consultarRegistros' })
        })
            .then(res => res.json())
            .then(data => {
                setApps(data);
            })
            .catch(err => console.error("Error al obtener datos:", err));
    }, [BASE_URL]);

    const actualizarFormulario = (e) => {
        const app = e.target.value;
        setAppSeleccionada(app);

        if (!app) {
            setCamposFormulario([]);
            return;
        }

        const appInfo = apps.find(item => item.Nombre === app);
        try {
            const campos = JSON.parse(appInfo?.datosApp || "[]");
            setCamposFormulario(Array.isArray(campos) ? campos : []);
        } catch (err) {
            console.error("Error al parsear campos:", err);
            setCamposFormulario([]);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const datos = Object.fromEntries(new FormData(e.target));
        datos.fecha = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

        fetch(`${BASE_URL}/models.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                datos:datos,
                page: 'nuevaStreamer',
            })
        })
            .then(res => res.text())
            .then(data => {
                //console.log("Respuesta cruda:", data);
                e.target.reset();
                setMensaje("Guardado correctamente ✅");
                setTimeout(() => setMensaje(""), 3000);
            })
            .catch(err => {
                console.error("Error al registrar:", err);
                setMensaje("❌ Error al guardar.");
                setTimeout(() => setMensaje(""), 3000);
            });
    };

    return (
        <main className="registrar">
            <br />
            <h1>Nueva Streamer</h1>
            <br />
            <form onSubmit={handleSubmit}>
                <label htmlFor="appNombre">Selecciona la App:</label>
                <select
                    id="appNombre"
                    name="appNombre"
                    value={appSeleccionada}
                    onChange={actualizarFormulario}
                    required
                >
                    <option value="">--Selecciona una App--</option>
                    {apps.map((app, idx) => (
                        <option key={idx} value={app.Nombre}>
                            {app.Nombre}
                        </option>
                    ))}
                </select>

                <br /><br />

                {camposFormulario.length > 0 && (
                    <div className="campo">
                        {camposFormulario.map((campo, idx) => (
                            <div key={idx}>
                                <label htmlFor={campo}>{campo}:</label>
                                <input type="text" name={campo} required />
                                <br />
                            </div>
                        ))}
                    </div>
                )}

                <button type="submit">Guardar</button>
            </form>

            {mensaje && <p style={{ color: "green" }}>{mensaje}</p>}
        </main>
    );
}

export default Prueba;
